var CookieServiceProvider = /** @class */function () {
  function CookieServiceProvider() {}
  CookieServiceProvider.prototype.setArkCookie = function (name, value, days) {
    if (days === void 0) {
      days = 1825;
    }
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;");
  };
  CookieServiceProvider.prototype.getArkCookie = function (name) {
    var match = document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]+)")));
    if (match) {
      return match[2];
    }
    return false;
  };
  CookieServiceProvider.prototype.removeArkCookie = function (name) {
    document.cookie = "".concat(name, "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    document.cookie = "".concat(name, "=; Domain=.").concat(location.hostname, "; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    document.cookie = "".concat(name, "=; Domain=.arkadium.com; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
  };
  return CookieServiceProvider;
}();
export var CookieService = new CookieServiceProvider();